import {Route, Routes, Outlet, Navigate, useNavigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {CategoryListWrapper} from './category-list/CategoryList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Plan Category',
    path: '/userplantype',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CategoryMasterPage = () => {
  const navigate = useNavigate()
  function goBack() {
    navigate(-1)
  }
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Plan Category</PageTitle>
              <button
                onClick={goBack}
                style={{marginBottom: '15px'}}
                className='btn btn-sm btn-info px-6 align-self-center text-nowrap'
              >
                <i className='bi bi-reply fs-4 me-2'></i> Go Back{' '}
              </button>
              <CategoryListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
    </Routes>
  )
}

export default CategoryMasterPage
